export default __webpack_public_path__ + "static/media/ex_img_07_2.b36800df.png";